/**
 * Approvals.
 *
 * `canDecide` and `cannotDecideReason` come back on every request, decided
 * server-side per record from the tabs and tier the operation itself needs. The
 * UI must not re-derive that — a button must never offer an approval the server
 * will refuse.
 */

import { apiGet, apiPost, buildQuery } from '../client.js';

/** Requests THIS person can decide. Already filtered server-side. */
export const fetchApprovalQueue = () =>
  apiGet('/api/approvals').then((data) => ({
    requests: data?.requests ?? [],
    enforcement: data?.enforcement ?? 'warn'
  }));

export const fetchMyApprovalRequests = (status) =>
  apiGet(`/api/approvals/mine${buildQuery({ status })}`).then((data) => data?.requests ?? []);

export const fetchApprovalRequest = (id) =>
  apiGet(`/api/approvals/${encodeURIComponent(id)}`).then((data) => data?.request ?? null);

export const approveRequest = (id, note) =>
  apiPost(`/api/approvals/${encodeURIComponent(id)}/approve`, { body: { note } });

export const rejectRequest = (id, note) =>
  apiPost(`/api/approvals/${encodeURIComponent(id)}/reject`, { body: { note } });

export const cancelApprovalRequest = (id) =>
  apiPost(`/api/approvals/${encodeURIComponent(id)}/cancel`);
